// extracted by mini-css-extract-plugin
export default {"toTopButton":"GoToTop_toTopButton__bNDfv"};